import React,{ useState, useEffect } from 'react';
import ReLoadButton from "../../components/IconButtons/ReLoadButton";
import { useStateContext } from '../../contexts/ContextProvider';
import { getAsignacionesFiltros } from "../../services/Asignaciones";
import { formatDate } from '../../formatters/date';
import { getProyectos } from "../../services/Proyectos";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';

import DataTable from 'react-data-table-component';
import { NuevaAsignacionTabs } from '../../components';
import { FolderIcon, UserIcon } from '@heroicons/react/24/solid';

const AsignaMaquina = () => {
  const { handleClick, isClicked } = useStateContext();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('ALL');
  const [proyecto, setProyecto] = useState('ALL');
  const [archivosData, setArchivosData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [proyectosData, setProyectosData] = useState([]);
  const [numeroSolicitud, setNumeroSolicitud] = useState('');
  const [centroCosto, setCentroCosto] = useState('');



  useEffect(()=>{
    const fetchData = async () => {
      const docuData = await getAsignacionesFiltros(selectedDate.toISOString(),selectedDateEnd.toISOString(),estado , numeroSolicitud, centroCosto );
      setArchivosData(docuData);
    };
    fetchData();
  },[selectedDate,selectedDateEnd,estado , numeroSolicitud, centroCosto]);

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), (today.getMonth()) -3, 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleChangeProyecto = (e) =>{
    setProyecto( e.target.value );
  }

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevaasignacion');
  };

  const handleRefreshDataTable = (opcion) => {
    if (opcion==="REFRESH"){
      const fetchData = async () => { 
        const docuData = await getAsignacionesFiltros(selectedDate.toISOString(),selectedDateEnd.toISOString(),estado , numeroSolicitud, centroCosto );
        setArchivosData(docuData);
      };
      fetchData();
    }
  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <ReLoadButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: 'Fecha Sol.',
      width: '120px',
      selector: row => formatDate(row.fechaSolicitud),
      sortable: true
    },
    {
      name: 'C.Costo',
      width: '100px',
      selector: row => row.codigoCentro,
      sortable: true
    },
    {
      name: 'Proyecto',
      width: '300px',
      selector: row => row.nombreProyecto,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <FolderIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreProyecto}</span>
      </div>
      )
    },
    {
      name: 'N° Sol.',
      width: '100px',
      selector: row => row.numeroSolicitud,
      sortable: true
    },
    {
    name: 'Estado',
    width: '120px',
    selector: row => row.estado,
    sortable: true,
    cell: (row) => {
      let bgColor = '';
      switch (row.estado) {
        case 'Aprobado':
          bgColor = 'bg-green-100 text-green-700';
          break;
        case 'Pendiente':
          bgColor = 'bg-yellow-100 text-yellow-700';
          break;
        case 'Asignado':
          bgColor = 'bg-blue-100 text-blue-700';
          break;
        default:
          bgColor = 'bg-gray-100 text-gray-700';
      }
      return (
        <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
          {row.estado}
        </div>
      );
    }
  },

    {
      name: 'Tipo',
      width: '120px',
      selector: row => row.tipoSolicitud,
      sortable: true
    },
    {
      name: 'Solicitante',
      width: '250px',
      selector: row => row.solicitante,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <UserIcon className="w-4 h-4 text-blue-500" />
        <span>{row.solicitante}</span>
      </div>
      )
    },
    {
      name: 'Jefe Of. Técnica',
      width: '250px',
      selector: row => row.nombreAprobador,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <UserIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreAprobador}</span>
      </div>
    )
    },
    {
        name: 'Administrador',
        width: '250px',
        selector: row => row.nombreAdministrador,
        sortable: true,
        cell: (row) => (
      <div className="flex items-center gap-2">
        <UserIcon className="w-4 h-4 text-blue-500" />
        <span>{row.nombreAdministrador}</span>
      </div>
    )
    }
  ];

  return (

<>
<div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Logística de Maquinas
              </p>
            </div>
        </div>
      <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mt-2 justify-between" >
              <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Desde</label>
                <SeleccionaFecha
                  selectedDate={selectedDate}
                  handleDateChange={handleDateChange}
                />
              </div>  
              <div className="flex flex-col mr-2">
              <label className="text-xs font-semibold mb-1">Hasta</label>
                <SeleccionaFecha
                  selectedDate={selectedDateEnd}
                  handleDateChange={handleDateChangeEnd}
                />
              </div>  
              {/* N° Solicitud */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">N° Solicitud</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 10234"
                value={numeroSolicitud}
                onChange={(e) => setNumeroSolicitud(e.target.value)}
              />
            </div>

            {/* Centro Costo */}
            <div className="col-span-1">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Centro Costo</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 0451"
                value={centroCosto}
                onChange={(e) => setCentroCosto(e.target.value)}
              />
            </div>

              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="Asignado">Asignado</option>
                  <option value="Aprobado">Aprobado</option>
                  </select>
              </div>  

            </div>
          </div>
      </div>

    <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
        <DataTable
          columns={columns}
          data={archivosData}
          highlightOnHover
          pagination={true}
          striped
          className="border border-gray-300 rounded-lg shadow-sm"
          noHeader={true}
          selectableRowsHighlight
          customStyles={customStyles}
          noDataComponent={'No hay Solicitudes creadas'}
        />
</div>
</div>
 
    </div>
     {isClicked.nuevaasignacion && (<NuevaAsignacionTabs vecinoData={laSucursal}  editableData="ON" onChangeVecino={handleRefreshDataTable}/>)}

</div>

    </>
  );
};

export default AsignaMaquina;